<style scoped>
.title-header {
  padding-top: 1rem !important;
  line-height: 24px !important;
  padding-bottom: 14px;
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
</style>

<template>
  <b-row>
    <b-col>
      <b-row class="title-header bg-anchor mb-3 ada-text-style">
        <b-col>
          <div>
            Top Active Loans
          </div>
        </b-col>
      </b-row>
      <loading-component
        :url="`/users/${this.$store.getters.user.id}/loan_summary`"
        error-message="Unable to load Payment dates"
        @success="summary = $event"
      >
        <summary-table
          date-field="maturity_date"
          title="Upcoming Maturity Dates"
          empty-text="You have no active deals yet."
          :items="maturitySectionData.items"
          :fields="maturitySectionData.fields"
        />
        <summary-table
          v-if="paymentDue.items.length"
          date-field="due_date"
          title="Payment Due Dates"
          :items="paymentDue.items"
          :fields="paymentDue.fields"
        />
      </loading-component>
    </b-col>
  </b-row>
</template>


<script>
import helper from '@/libs/helper';

import SummaryTable from '@/components/profile/sections/loan_summary/SummaryTable';
import LoadingComponent from '@/components/utils/LoadingComponent';

/* eslint no-underscore-dangle: ["error",
  { "allow": ["_rowVariant", "_cellVariants", "_id"] }] */

export default {
  components: {
    SummaryTable,
    LoadingComponent,
  },
  data() {
    return {
      summary: {},
      loading: false,
    };
  },
  computed: {
    maturitySectionData() {
      let items = [];
      if (this.summary.maturity_date) {
        const today = new Date();
        items = this.summary.maturity_date.map((p) => {
          const loan = p;
          loan.loan_id = loan._id;
          if (new Date(loan.maturity_date) < today) {
            loan._rowVariant = 'danger';
          }
          return loan;
        });
      }
      return {
        fields: [
          { key: 'maturity_date', label: 'Date' },
          { key: 'address', label: 'Address' },
        ],
        items,
      };
    },
    paymentDue() {
      let items = [];
      if (this.summary.payment_due) {
        const today = new Date();
        items = this.summary.payment_due.map((p) => {
          const payment = p;
          payment.loan_id = payment._id;
          if (new Date(payment.due_date) < today) {
            const diffDays = helper.dayDiff(today, new Date(payment.due_date));
            if (diffDays <= 11) {
              payment._cellVariants = { due_date: 'warning' };
            } else {
              payment._rowVariant = 'danger';
            }
          }
          return payment;
        });
      }

      return {
        fields: [
          { key: 'due_date', label: 'Due Date' },
          { key: 'address', label: 'Address' }],
        items,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/loan_summary/LoanSummary.vue